import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconGitFork } from '@tabler/icons-react';

/**
 * Used to insert an if block into the editor.
 */
export default function InsertIfBlock({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconGitFork />}
      label="Podmienený blok"
      onClick={() => editor?.chain().focus().setIfBlock().run()}
    />
  );
}
